module.exports = __webpack_public_path__ + "static/media/nepal.e9eadd2b.png";